/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext, useEffect, useRef } from 'react';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../app/store';
import EnvironmentHelper from '../../helpers/EnvironmentHelper';
import LocalStorageHelper from '../../helpers/LocalStorageHelper';
import JsonHelper from '../../library/helpers/JsonHelper';
import { BildirimModel } from '../../models/businessModels/BildirimModel';
import { BusinessHelper } from '../../helpers/BusinessHelper';
import GenelDurumHelper, { GenelDurumLoginStateHelper } from '../../helpers/GenelDurumHelper';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { useAppSelector } from '../../app/hooks';
import { getGenelDurumString } from '../../features/loadingMessageSlice';
import { GenelDurumViewModel } from '../../models/viewModels/GenelDurumViewModel';
import { useSnackbar, WithSnackbarProps } from 'notistack';

type Ctx = { conn: HubConnection | null };
const SignalRContext = createContext<Ctx>({ conn: null });
export const useSignalR = () => useContext(SignalRContext);

export const SignalRProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    /** ---------- refs ---------- */
    const connRef = useRef<HubConnection | null>(null);
    const dispatch = useDispatch<AppDispatch>();
    const dispatchRef = useRef(dispatch);
        const useAppSelectorRef = useRef(useAppSelector);
    
    /** her render’da en güncel navigate/dispatch’i sakla */
    useEffect(() => { dispatchRef.current = dispatch; }, [dispatch]);
    useEffect(() => { useAppSelectorRef.current = useAppSelector; }, [useAppSelector]);
    const mySnackbar = useSnackbar();
   
    const genelDurum = GenelDurumHelper.StringToModel(useAppSelectorRef.current(getGenelDurumString)!)!;
    const gdRef = useRef(genelDurum);
    gdRef.current = genelDurum;

    /** ---------- bağlantıyı tek sefer kur ---------- */
    useEffect(() => {
        if (connRef.current) return;                 // zaten kurulduysa çık

        console.log('Creating HubConnection');

        const c = new HubConnectionBuilder()
            .withUrl(EnvironmentHelper.GlobalMainEndpoint() + 'notificationHub', {
                accessTokenFactory: () => LocalStorageHelper.getToken()!,
            })
            .withAutomaticReconnect()
            .build();

        /* mesaj dinleyicileri */
        c.on('recievenotification', (payload) => {
            notificationReceived(payload, dispatchRef.current, mySnackbar, () => gdRef.current);
        });

        c.on('recievenotificationforlog', (msg) =>
            console.log('Received message:', msg),
        );

        c.start()
            .then(() => console.log('SignalR connected'))
            .catch((err) => console.error('SignalR error', err));

        connRef.current = c;                         // ref’e ata
    }, []);

    /** cleanup – component unmount’ta bağlantıyı kapat */
    useEffect(() => () => {
        console.log('Stopping HubConnection'),
        connRef.current?.stop();
    }, []);

    return (
        <SignalRContext.Provider value={{ conn: connRef.current }}>
            {children}
        </SignalRContext.Provider>
    );
};



function notificationReceived(payload: any, dispatch: AppDispatch, mySnackbar: WithSnackbarProps, genelDurumGetter: () => GenelDurumViewModel /*current: UseAppSelectorType*/): any {
    const bildirim = JsonHelper.deepCopy(payload as BildirimModel);
    const genelDurum = genelDurumGetter();

    if (genelDurum.bildirimList.any(e => e.id === bildirim.id) || bildirim.kullaniciAdi !== genelDurum.kullanici.kullaniciAdi)
        return;

    GenelDurumLoginStateHelper.GenelDurumStateGuncelle(dispatch, genelDurum,
        (newGenelDurum) => {
            const newBildirimList = newGenelDurum.bildirimList.slice();
            newBildirimList.push(bildirim);
            newGenelDurum.bildirimList = newBildirimList;
        });

    const bildirimBilgi = BusinessHelper.Bildirim.GetBildirimBilgi(bildirim, genelDurum);
    NotificationHelper.Send(bildirimBilgi.title, bildirim.icerik, bildirimBilgi.to, mySnackbar);
}
// // SignalRContext.tsx
// import React, { createContext, useContext, useEffect, useState } from 'react';
// import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
// import EnvironmentHelper from '../../helpers/EnvironmentHelper';
// import LocalStorageHelper from '../../helpers/LocalStorageHelper';

// interface SignalRContextType {
//   connection: HubConnection | null;
// }

// const SignalRContext = createContext<SignalRContextType>({ connection: null });

// export const useSignalR = () => useContext(SignalRContext);

// export const SignalRProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [connection, setConnection] = useState<HubConnection | null>(null);

//   useEffect(() => {
//     if (connection === null) {
//       const newConnection = new HubConnectionBuilder()
//         .withUrl(EnvironmentHelper.GlobalMainEndpoint() + "notificationHub", {
//           accessTokenFactory: () => LocalStorageHelper.getToken()!
//         })
//         .withAutomaticReconnect()
//         .build();

//       newConnection.on('recievenotification', (message) => {
//         // handle your notification
//       });

//       newConnection.on('recievenotificationforlog', (message) => {
//         console.log('Received message:', message);
//       });

//       newConnection
//         .start()
//         .then(() => {
//           console.log("SignalR connected");
//           setConnection(newConnection);
//         })
//         .catch(err => console.error("SignalR connection error:", err));
//     }
//   }, [connection]);

//   return (
//     <SignalRContext.Provider value={{ connection }}>
//       {children}
//     </SignalRContext.Provider>
//   );
// };
